<template>
  <b-modal
    :id="refModal"
    :ref="refModal"
    title="Thêm sản phẩm từ Excel"
    size="lg"
    hide-footer
    @hidden="resetImportState"
  >
    <b-row>
      <b-col>
        <div class="form-group">
          <span>
            <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel
            đúng format, hoặc có thể tải ở
            <a :href="urlExcel">đây</a>
          </span>
        </div>
      </b-col>
    </b-row>
    <!-- Nhập file -->
    <b-row>
      <b-col cols='12'>
        <span>
          <b>Bước 2:</b> Nhập sản phẩm và tải lên
        </span>
        <UploadFileMulter
          :key="uploadKey"
          v-on:send-file="getDataFromExcel"
          v-on:clear-file="clearFileExcel"
          :cmdUrl="importUrl"
        />
        <span v-if="fileName">Tên file: <b>{{ fileName }}</b>
        </span>
      </b-col>
    </b-row>

    <b-row class="step-3">
      <b-col>
        <span>
          <b>Bước 3:</b> Lưu
        </span>
      </b-col>
    </b-row>
    <b-container
      class="mt-4 pl-0 pr-0"
      v-show="importItems.length"
    >
      <h5>
        Danh sách sản phẩm từ file excel( Tổng:
        {{ importItems.length }} sản phẩm)
      </h5>
      <b-table
        responsive
        bordered
        hover
        :fields="fieldImport"
        :items="importItems"
        :current-page="currentPage"
        :per-page="maxItems"
        small
      >
        <template v-slot:cell(productName)="row">
          <span>{{ row.item.productName }}</span>
          <span
            v-if="isNonSellableProduct(row.item)"
            class="label label-inline label-light-danger ml-1"
          >Ngừng bán</span>
        </template>
      </b-table>
      <b-pagination
        v-show="importItems.length > maxItems"
        v-model="currentPage"
        :total-rows="rowsTable"
        :per-page="maxItems"
        aria-controls="my-table"
      ></b-pagination>
    </b-container>
    <div class="footer">
      <b-button
        :disabled="!isValid"
        class="cta-btn"
        variant="primary"
        size="sm"
        @click="save"
      >Lưu</b-button>
      <b-button
        class="cta-btn ml-4"
        variant="secondary"
        size="sm"
        @click="$bvModal.hide(refModal)"
      >Hủy</b-button>
    </div>
  </b-modal>
</template>

<script>
import UploadFileMulter from '@/view/modules/upload/UploadFileMulter';
import { EventBus } from '@/core/services/event-bus';
import { BASE_URL } from '@/utils/constants';
import { convertPrice, makeToastFaile } from '@/utils/common';
import { PRODUCT_STATUS } from '@/utils/enum';

export default {
  components: {
    UploadFileMulter,
  },
  props: {
    storeId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      refModal: 'import-complete-modal',
      importItems: [],
      fieldImport: [
        {
          key: 'productCode',
          label: 'Mã sản phẩm',
          sortable: false,
        },
        {
          key: 'productName',
          label: 'Tên sản phẩm',
          sortable: false,
        },
        {
          key: 'imeiNo',
          label: 'Mã IMEI',
          sortable: false,
        },
        {
          key: 'quantity',
          label: 'Số lượng',
          sortable: false,
          tdClass: 'text-right',
        },
        {
          key: 'sellingPrice',
          label: 'Giá bán',
          sortable: false,
          tdClass: 'text-right',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        {
          key: 'errors',
          label: 'Lỗi',
          sortable: false,
        },
      ],
      fileName: '',
      urlExcel: BASE_URL + 'media/upload/stock/Temp_Import_Complete.xls',
      file: null,
      currentPage: 1,
      totalRow: 0,
      isValid: true,
      maxItems: 8,
      uploadKey: 0,
    };
  },
  watch: {
    // Preview chỉ đúng với kho đã kiểm; đổi kho mà giữ bảng cũ là Lưu nhầm dữ liệu kho khác.
    storeId() {
      this.resetImportState();
    },
  },
  computed: {
    rowsTable() {
      return this.importItems.length;
    },
    importUrl() {
      return `stocks/import-completion-excel?storeId=${this.storeId || ''}`;
    },
  },
  methods: {
    save() {
      EventBus.$emit('importCompleteExcel', this.importItems);
      this.$bvModal.hide(this.refModal);
    },
    getDataFromExcel(data, fileName) {
      this.isValid = data.valid;
      this.fileName = fileName;
      if (!data.rows) {
        this.importItems = [];
        return makeToastFaile(data.message || 'Dữ liệu excel không hợp lệ');
      }
      this.importItems = data.rows.map((item) => {
        return {
          ...item,
        };
      });
    },
    isNonSellableProduct(item = {}) {
      return item.status === PRODUCT_STATUS.STOP_SELLING;
    },
    resetImportState() {
      this.importItems = [];
      this.fileName = '';
      this.isValid = true;
      this.currentPage = 1;
      this.uploadKey += 1;
    },
    clearFileExcel() {
      this.resetImportState();
    },
  },
};
</script>

<style lang="scss" scoped>
.cta-btn {
  font-weight: 600;
  width: 70px;
}
.footer {
  margin-top: 20px;
}
.step-3 {
  margin-top: 20px;
}
</style>